/**
 * @file XCOMM Account related fragments.
 */

import gql from 'graphql-tag';

export const AccountDetails = gql`
  fragment AccountDetails on Account {
    id
    email_address
    username
    name
    phone_number
    organization_name
    slug
  }
`;

export const CommanderPermissions = gql`
  fragment CommanderPermissions on Account {
    commander_permission {
      can_view_assignments_only
      can_match
      can_flush
    }
  }
`;
